import { useObservable } from "@faire/web/ui/hooks/useObservable";
import { computed } from "mobx";
import { DependencyList } from "react";

/**
 * Hook-equivalent to @computed. When the derived value stays the same, component will not re-render.
 * Use this hook instead of useMemo when the computeFn depends on a mobX observable object/array.
 */
export const useComputedObservable = <T>(
  computeFn: () => T,
  deps: DependencyList = []
) => {
  return useObservable(() => computed(computeFn).get(), deps);
};
